import React from 'react'
import Breadcrumbs from '../Breadcrumbs'
import '../../css/desembarquePasajero.scss'
import Footer from '../Footer'

export default function DesembarquePasajero() {
  return (
    <>
    <section className='desembarque'>

        {/* HERO */}
          <div className='desembarque-pasajero-hero'>

              <div className='overlay'></div>

              <div className='container hero-content'>

                  <div style={{ marginTop: '4rem' }}>
                      <Breadcrumbs />
                  </div>

                  <h1>
                      Desembarque para pasajeros sin automóvil
                  </h1>

                  <p>
                      Desembarque seguro y organizado para pasajeros sin automóvil, con indicaciones claras y asistencia disponible.
                  </p>

              </div>

          </div>

        <div className='container'>


          <div className='desembarque-grid'>

            {/* CONTENIDO */}
            <div className='desembarque-content'>

             

              {/* MINI CARDS */}
              <div className='desembarque-mini-grid'>

                <div className='desembarque-mini-card'>

                  <span className="material-symbols-outlined filled">
                    <i class="fi fi-rs-room-service"></i>
                  </span>

                  <h3>Equipo de Hotelería</h3>

                  <p>
                    El personal de hotelería dará inicio al desembarque,
                    coordinando la salida por grupos para evitar aglomeraciones.
                  </p>

                </div>

                <div className='desembarque-mini-card'>

                  <span className="material-symbols-outlined filled">
                    <i class="fi fi-rs-bus-alt"></i>
                  </span>

                  <h3>Transporte a Terminal</h3>

                  <p>
                    El traslado será por medio de un autobús proporcionado
                    por la empresa que los llevará hasta la entrada
                    a la terminal.
                  </p>

                </div>

              </div>

               {/* CARD PRINCIPAL */}
              <div className='desembarque-main-card'>

                <div className='desembarque-icon-circle'>
                  <span className="material-symbols-outlined">
                    <i class="fi fi-rs-shield-check"></i>
                  </span>
                </div>

                <div>
                  <h2>Indicaciones de Seguridad</h2>

                  <p>
                    Los pasajeros que viajan sin automóvil deberán esperar la
                    indicación para desembarcar de forma segura y ordenada.
                    Manténgase en las áreas designadas de espera hasta que
                    nuestro personal lo autorice.
                  </p>
                </div>

              </div>

            </div>

            {/* SIDEBAR */}
            <div className='desembarque-sidebar'>

              <div className='desembarque-wait-card'>
                <h2>
                  <span className="material-symbols-outlined">
                    <i class="fi fi-rs-clock"></i>
                  </span>

                  Tiempo de Espera
                </h2>

                <div className='desembarque-time'>

                  <div className='desembarque-time-row'>
                    <strong>30-60</strong>
                    <span>min</span>
                  </div>

                  <div className='desembarque-progress'>
                    <div className='desembarque-progress-bar'></div>
                  </div>

                </div>

                <p className='desembarque-wait-text'>
                  El tiempo de desembarque puede variar de 30 minutos a 1 hora,
                  dependiendo de las indicaciones proporcionadas a bordo.
                </p>

                <div className='desembarque-info-box'>

                  <span className="material-symbols-outlined">
                    <i class="fi fi-rs-info"></i>
                  </span>

                  <p>
                    Estimación basada en flujo regular de pasajeros.
                  </p>

                </div>

              </div>

            </div>

          </div>
        </div>
      </section>

      {/* SOPORTE */}
      <section className='desembarque-support'>

        <div className='container'>

          <div className='desembarque-support-content'>

            <h2>¿Necesita asistencia adicional?</h2>

            <p>
              Nuestro equipo está disponible en todo momento para ayudarle
              con su equipaje o cualquier requerimiento especial durante
              el desembarque.
            </p>

            <div className='desembarque-support-buttons'>

        
               <a href='https://www.bajaferries.com.mx/preguntas-frecuentes' target='_blank' rel="noreferrer" className='durante-link'>
                    Preguntas Frecuentes <i class="fi fi-rr-arrow-up-right-from-square"></i>
                  </a>

            </div>

          </div>

        </div>

      </section>
      <Footer />
    </>
  )
}
